import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';
import { GenericService } from '../generic.service';

@Component({
  selector: 'app-annuaire',
  templateUrl: './annuaire.component.html',
  styleUrls: ['./annuaire.component.css']
})
export class AnnuaireComponent implements OnInit {


//Informations personnelles des consultants
public config: any;
public order: string = "prenom";
public reverse: boolean = false;
public sortedCollection: any[];
searchText: string;
public listDetailconsultants: any[] = [];
public filterlistDetailconsultants: any[] = [];
public countDoublon : number = 0;


//Variable permettant de stocker le profil des utilisateurs ayant le rôle ADMIN ou MANAGER
public firtNameManager: any;
public managers = [];
public newArray: any;


  constructor(public _authService: AuthService, private _genericService: GenericService) { }

  ngOnInit() {
    this.getAllManagers();
    this.getInfoConsultants();

  }




  //récupérer le prénom des utilisateurs ayant le role AMIN ou MANAGER
  getAllManagers(){
    this._genericService.getResource(environment.statsTotalManagers, true, 0)
    .subscribe(
      result =>{
        this.firtNameManager = result;
        for (let i = 0; i < this.firtNameManager.length; i++) {
          this.managers.push({
            prenom: this.firtNameManager[i].prenom, 
            nom: this.firtNameManager[i].nom, 
            telephone: this.firtNameManager[i].telephone, 
            email: this.firtNameManager[i].email, 
            profil: "Manager", 
          });
        }
      },
      error =>{
      }
    );
  }

  //Récupérer les informations personnelles des consultants ainsi que les détails du contrat
  getInfoConsultants(){
    this._genericService.getResource(environment.statsgetInfoConsultants, true, 0)
    .subscribe(
      data =>{
        //configuration pour la pagination
        for (let u = 0; u < data.length; u++) {
        }
        this.config = {
          itemsPerPage: 10,
          currentPage: 1,
          //totalItems: this.listDetailconsultants.length
        };

        
        let contrat
        for (let i = 0; i < data.length; i++) {
          let numberValue = (data[i].fe.actions.publishNumber != undefined && data[i].fe.actions.publishNumber === true) ? ' ': data[i].general.telephone
          let emailValue =  (data[i].fe.actions.publishEmail != undefined && data[i].fe.actions.publishEmail === true) ? ' ': data[i].general.email ;
          this.listDetailconsultants.push({ prenom: data[i].general.prenom, 
            nom: data[i].general.nom, 
            telephone: numberValue, 
            email: emailValue, 
            profil: data[i].general.profil, 
          });
        }

        //Filter les données en supprimant les doublons
        for (let j = 0; j < this.listDetailconsultants.length; j++){
          for(let k = 0; k < this.managers.length; k++){
            if(this.listDetailconsultants[j].prenom == this.managers[k].prenom  && this.listDetailconsultants[j].nom == this.managers[k].nom){
              delete this.listDetailconsultants[j];                                                                                 
              this.countDoublon  = this.countDoublon + 1;
            }
            
        }
      }
        // Rajouter le profil des ADMIN ou MANAGER dans la liste des collaborateurs
        this.newArray = [...this.listDetailconsultants, ...this.managers];
      },
      error =>{
        console.log(error);
      }
    )
  }

  

  //pagination du tableau des consultants
  pageChanged(event: any){
    this.config.currentPage = event;
  }

  //Ranger les élements du tableau
  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }

    this.order = value;
  }













  

}









// WEBPACK FOOTER //
// ./src/app/annuaire/annuaire.component.ts